import React from "react";

const Header: React.FC = () => {
  return <header></header>;
};
export default Header;
